import { Component } from '@angular/core';

@Component({
	templateUrl: '../../../../../assets/svg/detail.svg',
})
export class DetailComponent {}
